export namespace MathUtils {
    /**
     * Calculates the factorial of a given number recursively.
     *
     * @param {number} i - the number for which to calculate the factorial
     * @return {number} the factorial of the input number
     */
    export const factorial = (i: number) => {
        if (i <= 1) {
            return 1;
        }
        return i * factorial(i - 1);
    };

    /**
     * Calculates the number of combinations of n choose r.
     *
     * @param {number} n - the total number of items
     * @param {number} r - the number of items to choose
     * @return {number} the number of combinations
     */
    export const combinations = (n: number, r: number) => {
        if (n == r) {
            return 1;
        } else {
            r = r < n - r ? n - r : r;
            return multiplicationRange(r + 1, n) / multiplicationRange(1, n - r);
        }
    };

    /**
     * Generates a range of numbers from `start` to `stop` with a given `step`.
     *
     * @param {number} start - The starting number of the range.
     * @param {number} stop - The ending number of the range.
     * @param {number} [step=1] - The step size between each number in the range.
     * @return {number[]} An array of numbers from `start` to `stop` with a step size of `step`.
     */
    export const range = (start: number, stop: number, step = 1) => {
        return [...Array(stop - start).keys()].filter((i) => !(i % Math.round(step))).map((v) => start + v);
    };

    /**
     * Calculates the multiplication of numbers in a range from 'a' to 'b'.
     *
     * @param {number} a - The starting number of the range.
     * @param {number} b - The ending number of the range.
     * @return {number} The result of the multiplication in the specified range.
     */
    function multiplicationRange(a: number, b: number) {
        let r = a,
            i = a;

        while (i++ < b) {
            r *= i;
        }
        return r;
    }
}
